import React, { useEffect } from 'react';

const Toast = ({ message, type = 'success', onClose, action = null }) => {
  useEffect(() => {
    // Don't auto-dismiss if there's an action button — wait for user input
    if (action) return;
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose, action]);

  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
    partial: '⚠',
};

  return (
    <div className="fr-toast-overlay">
      <div className={`fr-toast ${type}`}>
        <span className="fr-toast-icon">
          {icons[type] || icons.info}
        </span>
        <span className="fr-toast-message">{message}</span>
        {action && (
          <div className="fr-toast-actions">
            <button
              className="fr-toast-action-btn fr-toast-action-confirm"
              onClick={(e) => {
                e.stopPropagation();
                action.onClick();
              }}
            >
              {action.label || 'Confirm'}
            </button>
            <button
              className="fr-toast-action-btn fr-toast-action-cancel"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Toast;